// The error vocabulary of core.md §14, one key per code.
export const errors = {
  // ── errors ───────────────────────────────────────────────────────────
  'errors.generic': 'Something went wrong.',
  'errors.loadFailed': 'Could not load.',
  'errors.saveFailed': 'Could not save.',
  'errors.deleteFailed': 'Could not delete.',
  'errors.invalidInput': 'Some of what you entered is not valid.',
  'errors.insufficientCredits': 'Not enough Parseh for this action.',
  'errors.unavailable': 'The service is not available right now.',
  'errors.unavailableBody': 'The server did not answer. Nothing was lost — try again in a moment.',
  'errors.notFound': 'Not found.',
  'errors.encounterClosed': 'This visit is closed. Reopen it to make changes.',
  'errors.anotherEncounterOpen': 'Another visit is already open for this patient.',
  'errors.caseArchived': 'This patient is archived. Unarchive it to start a visit.',
  'errors.threadNotFound': 'That conversation no longer exists.',
  'errors.queryTooComplex': 'The request was too large. Reopen the page.',
  'errors.offline': 'You are offline.',
};

export default errors;
